import { FeatureCard } from './FeatureCard';

export type { TypeFeatureCardProps } from './types';
export default FeatureCard;
